import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';
import AuthService from '../service/auth';

const ProtectedRoute = (props) => {
    const allowedRoles = props.allowedRoles || []
    const requireNoUser = props.requireNoUser === true
    const bypass = props.bypass === true
    const authContext = React.useContext(AuthContext);;
    const notAuthenticatedPaths = ["user/login", "user/registration"]
    const { companyID } = useParams();
    const location = useLocation();

    if (bypass) {
        return props.children;
    }

    if (!authContext) {
        return (notAuthenticatedPaths.includes(props.path)) ? props.children :
            <Navigate to="/user/login" state={{ from: location.pathname + location.search + location.hash }} replace />;
    } else if (requireNoUser === true) {
        return <Navigate to={location.state?.from || "/"} replace />;
    } else if (allowedRoles.length > 0) {
        const context = Object.assign({}, authContext)
        if (companyID) {
            Object.assign(context, { entityId: companyID })
        }

        if (!AuthService.hasAnyRole(context, allowedRoles)) {
            if(props.condition) {
                if(!props.condition()) {
                    return <Navigate to="/notEnoughPriviliges" replace />
                }
            }else {
                return <Navigate to="/notEnoughPriviliges" replace />
            }
        }
    }

    return props.children;
};

const NonProtectedRoute = ({ requireNoUser, children }) => {

    const authContext = React.useContext(AuthContext);;

    if (authContext && requireNoUser) {
        return <Navigate to="/" replace />

    }

    return children;
};

export { ProtectedRoute, NonProtectedRoute } 